import React, { useEffect } from 'react';
import Header from '../../comps/header'
import { checkLoggedIn } from '../../tools/settings';
import { useCMS } from 'tinacms';
import { usePlugin, useForm } from 'tinacms'
import { InlineForm } from 'react-tinacms-inline'
import useSettings from "../../tools/settings"
import Footer from "../../comps/footer"
import StickyContact from "../../comps/sticky-contact"
import WysiwigBlock from "../../comps/wysiwyg"

function Page() {
    const cms=useCMS();
    useEffect(()=>checkLoggedIn(cms),[cms]);

    const settings = useSettings(["mentionContent"])
    // 1. Define the form
    const FormOptions = {
      id:"mentions",
      loadInitialValues() {
         let data = settings.get();
         console.log(data);
         return(data)
      },
      onSubmit: (content) => settings.save(content)
    }
  
    // 2. Pass the form as the second argument
     const [content, form] = useForm(FormOptions)
     // 3. Register the form as a plugin
     usePlugin(form)
    return <>
        <Header />
        <InlineForm form={form}>
        <div class="page">
          <WysiwigBlock content={content} groupName="mentionContent" />
        </div>
        </InlineForm>
        <StickyContact />
        <Footer />


    </>
}

export default Page;